<template>
  <span v-if="show">
        <div class="w3-container">
            <h4 class="page-title">BEMUTATKOZÁS</h4>
            <div class="w3-justify">
                <p>Tisztelt Látogató!</p>
                <p>A Libertate polgári társulás 2016-ban alakult meg, elsődleges célja a felvidéki magyarság megmaradása, az identitástudat erősítése. Többek között a kultúra, a sport és a környezetvédelem területein tevékenykedünk Dél-Szlovákiában.</p>
                <p>Polgári társulásunk további tevékenységeiről, programjairól tájékozódhat a logóra kattintva:</p>
            </div>
            <div class="w3-justify">
                <div class="w3-margin-top">A csavarGO egy PWA (Progressive Web Apps) weboldal, mely a telefonon alkalmazásként tud megjelenni és offline állapotban is használható. A folyamatosan online térben tartózkodó gyermekek és felnőttek számára kiváló motivációt jelenthet:
                    <div class="w3-margin-left">
                        <li>a mozgásra, fizikai erőnlét fejlesztésére;</li>
                        <li>a magyarságtudat erősítésére;</li>
                        <li>a környezettudatos viselkedés kialakítására;</li>
                        <li>a természetvédelemre való nevelésre;</li>
                        <li>a családok, illetve gyermekcsoportok közös, hasznos időtöltésére.</li>
                    </div>
                </div>
                <p>Weboldalként a Felvidéken található túraútvonalakat nyilvántartó adatbázis. Az oldal  körtúra útvonalakkal indul (gyalogtúra vagy kerékpártúra). Első körben a Csallóközt, Mátyusföldet a Duna mentét céloztuk meg, melyek a jövőben új útvonalakkal bővülnek a Felvidék különböző területein.</p>
                <p>A weboldalon az útvonalakról és az útvonalon található látnivalókról információs anyagot böngészhetnek a túrázók, valamint térkép nézetben láthatják az adott útvonal nyomvonalát és az útvonalon elhelyezett látnivalókat/ellenőrző pontokat.</p>
                <p>A csavarGO alkalmazással az adatbázisában található útvonalak igazolt teljesítésére is van lehetőség. Az útvonal teljesítésének „bizonyítása” az útvonalon elhelyezett ellenőrző pontok érintésének igazolásával történik. Ez az igazolás a telefon GPS-e segítségével történik. Az igazolt teljesítéseknek köszönhetően a regisztrált felhasználók pontokat gyűjthetnek, amely alapján jutalomban részesülnek.</p>
            </div>
            <div class="w3-justify">
                <p>Töltsenek el a csavarGOval egy-egy kellemes és élménydús napot a természetben, s ismerjék meg a Felvidék gyönyörű tájait!
                Iratkozzanak fel a <a href="https://www.youtube.com/channel/UCqkzy2l53YrTc6m5CnLc-9A">YouTube csatornánkra</a> és kövessenek bennünket a <a href="https://www.facebook.com/Csavargo-110810777436465/">Facebookon</a>!
                </p>
                <p>Dr. Nyilfa Péter, a Libertate elnöke</p>
            </div>    
            <div class="w3-row-padding">
                <div class="w3-center w3-half w3-margin-top ">
                    <a href="https://libertate.sk" target="_blank"><img class="responsive-img w3-card-2" src="../assets/img/melleklet1.jpg" ></a>
                </div>
                <div class="w3-center w3-half w3-margin-top">
                    <a href="https://bgazrt.hu/" target="_blank"><img class="responsive-img w3-card-2" src="../assets/img/melleklet2.jpg" ></a>
                </div>
            </div>


        </div>

        <div class=" w3-center w3-margin-top w3-padding-24 menu-title-color">
            Copyright csavarGO.eu - 2024<br>
            Verzió: {{$appData.versionNumber}}<br>
            <div v-if="$parent.cookie==1" class="cursorpointer" v-on:click="$parent.cookie=3">Cookie beállítások módosítása</div>  
            <div v-on:click="$openPage(1)" class="cursorpointer ">Adatkezelési szabályzat</div>
        </div>          
    </span>
</template>

<script>
export default {
  name: 'Intro',
  data() {
      return {
          show: false, //erre a beállításra azért van szükség, hogy az oldal a lap tetején jelenjen meg.
      }
  },
  methods: {
    goPageTop(){
      window.scrollTo(1, 1); 
      this.show=true;
    },
  },
  mounted () {
    this.goPageTop(); //betöltéskor ugrás a lap tetejére
  }
}
</script>

